export default __webpack_public_path__ + "3608b6ac98ede57fc01206ade81d08a9.png";